import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../../environments/environment';

export const authoriseGuard: CanActivateFn = (route) => {
  if (!environment.production && globalThis.location.hostname === 'localhost') return true;

  const router = inject(Router);
  const auth = inject(AuthenticationService);
  const screenKey = ((route.data?.['screenKey'] as string | undefined) ?? '').toUpperCase();
  if (!screenKey) return true;
  const screens = auth.getStaticData()?.SCREENS;
  const isPlainObject = screens != null && typeof screens === 'object' && !Array.isArray(screens);
  // Legacy / not-gated shape (null, undefined, or array) — no gating enforced.
  if (!isPlainObject) return true;
  if (Object.hasOwn(screens, screenKey)) return true;
  // SCREENS is a plain object that doesn't grant this screen.
  // Empty object → user has no accessible screens at all → force re-login.
  // Non-empty object → user has other screens but not this one → bounce to /agents.
  if (Object.keys(screens).length > 0) {
    router.navigate(['/agents']);
  } else {
    router.navigate(['/login'], { queryParams: { reason: 'no_access' } });
  }
  return false;
};
